<template>
    <div v-loading="childLoading" class="modeStyle-contain">
        <!-- 创单抽成配置 -->
        <div style="height: 60vh; overflow-y: auto">
            <div style="margin-top: 20px" v-if="activeName == '3'">
                是否开启
                <el-switch v-model="awaitPayMode_status_children" active-value="1" inactive-value="0"> </el-switch>

                创单抽成启用后，司机不在遵循模式一或模式二抽成规则，非创单依旧遵循
            </div>

            <!-- 配置-抽成配置-司机抽成-模式二和创单抽成配置 -->
            <div class="second-main-wrap">
                <!-- 标题前小方块 + 标题 + 生效中/空闲中按钮  -->

                <!-- 全职司机 -->
                <div class="mode_submit-data">
                    <div class="mode-head">
                        <!-- 标题前小方块 -->
                        <div class="title-square"></div>
                        <!-- 标题 -->
                        <span style="display: inline-block">全职司机抽成（默认）</span>
                    </div>
                    <div class="disTitle">
                        <span class="span-mode">固定金额抽成</span>
                        <div>
                            <el-input
                                v-model="submit_data_children.two_full_money"
                                class="input-item1 input-item-active"
                                placeholder="固定金额抽成"
                            >
                            </el-input>
                            元
                        </div>
                    </div>
                    <div class="disTitle">
                        <span class="span-mode">百分比金额抽成</span>
                        <div>
                            <el-input
                                v-model="submit_data_children.two_full_rate"
                                class="input-item1 input-item-active"
                                placeholder="订单金额百分比抽成"
                            >
                            </el-input>
                            %
                        </div>
                    </div>
                    <el-button class="btn1" type="info" @click="selectTimeChangeQ">自定义时间段抽成</el-button>
                    <div v-if="selectTimeQ_children == true">
                        <div>
                            <div class="btnTitle">
                                <span class="title-a">抽成生效时间段:</span>
                                <el-button @click="addContent('qz')" type="success" class="btnSelect" icon="el-icon-plus"></el-button>
                            </div>

                            <div v-for="(item, index) in full_synchronization_children" :key="index" class="box-content">
                                <div style="display: flex; justify-content: flex-end">
                                    <el-button type="danger" @click="delData(index, 'qz')" icon="el-icon-close"></el-button>
                                </div>

                                <div>
                                    <div class="disTitle">
                                        <span class="span-mode">全职司机抽成：</span>
                                        <div>
                                            <el-input
                                                v-model="full_synchronization_children[index].full_money"
                                                class="input-item1 input-item-active"
                                                placeholder="固定金额抽成"
                                            >
                                            </el-input>
                                            元
                                        </div>
                                    </div>
                                    <div class="disTitle">
                                        <span class="span-mode"></span>
                                        <div>
                                            <el-input
                                                v-model="full_synchronization_children[index].full_rate"
                                                class="input-item1 input-item-active"
                                                placeholder="订单金额百分比抽成"
                                            >
                                            </el-input>
                                            %
                                        </div>
                                    </div>

                                    <!-- 选择时间 -->
                                    <div class="disTitle">
                                        <span class="span-mode">抽成生效时间：</span>
                                        <div>
                                            <el-time-picker
                                                v-model="full_synchronization_children[index].time_start"
                                                :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                                                placeholder="抽成生效时间"
                                                value-format="HHmm"
                                                format="HH:mm"
                                                class="timeX"
                                            >
                                            </el-time-picker>
                                        </div>
                                    </div>
                                    <div class="disTitle">
                                        <span class="span-mode">抽成结束时间：</span>
                                        <div>
                                            <el-time-picker
                                                v-model="full_synchronization_children[index].time_end"
                                                :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                                                placeholder="抽成结束时间"
                                                value-format="HHmm"
                                                format="HH:mm"
                                                class="timeX"
                                            >
                                            </el-time-picker>
                                        </div>
                                    </div>
                                    <div class="modeStyle">
                                        <el-button
                                            class="edit-btn"
                                            @click="editModeBtn('full', index, checkboxChangeQ(index))"
                                            type="primary"
                                            >编辑</el-button
                                        >
                                        <!-- {{ allModeArr_children.length 全职sync}} -->
                                        <div>
                                            <span class="span-mode">订单模式：</span>
                                            <!-- {{ checkboxChangeQ(index).length }}--{{ allModeArr_children.length }} -->
                                            <!-- {{ full_synchronization_children[index].full_order_mode_code_array.length }}--{{
                                                allModeArr_children.length
                                            }} -->
                                            <!-- <div v-if="full_synchronization_children[index].full_order_mode_code_array.length == allModeArr_children.length">
                                                <el-tag type="info">全部</el-tag>
                                            </div> -->

                                            <div v-if="checkboxChangeQ(index).length == allModeArr_children.length">
                                                <el-tag type="info">全部</el-tag>
                                            </div>
                                            <div v-else>
                                                <el-checkbox-group
                                                    v-model="full_synchronization_children[index].full_order_mode_code_array"
                                                    disabled
                                                >
                                                    <el-checkbox
                                                        v-for="(item, index1) in checkboxChangeQ(index)"
                                                        :label="item.order_mode.order_mode_code"
                                                        :key="index1"
                                                    >
                                                        {{ item.name }}
                                                    </el-checkbox>
                                                </el-checkbox-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 兼职司机 -->
                <div class="mode_submit-data">
                    <div class="mode-head">
                        <!-- 标题前小方块 -->
                        <div class="title-square"></div>
                        <!-- 标题 -->
                        <span style="display: inline-block">兼职司机抽成（默认）</span>
                    </div>
                    <div class="disTitle">
                        <span class="span-mode">固定金额抽成</span>
                        <div>
                            <el-input
                                v-model="submit_data_children.two_part_money"
                                class="input-item1 input-item-active"
                                placeholder="固定金额抽成"
                            >
                            </el-input>
                            元
                        </div>
                    </div>
                    <div class="disTitle">
                        <span class="span-mode">百分比金额抽成</span>
                        <div>
                            <el-input
                                v-model="submit_data_children.two_part_rate"
                                class="input-item1 input-item-active"
                                placeholder="订单金额百分比抽成"
                            >
                            </el-input>
                            %
                        </div>
                    </div>
                    <el-button class="btn1" type="info" @click="selectTimeChangeJ">自定义时间段抽成</el-button>
                    <div v-if="selectTimeJ_children == true">
                        <div>
                            <div class="btnTitle">
                                <span class="title-a">抽成生效时间段:</span>
                                <el-button @click="addContent('jz')" type="success" class="btnSelect" icon="el-icon-plus"></el-button>
                            </div>

                            <div v-for="(item, index) in part_synchronization_children" :key="index" class="box-content">
                                <div style="display: flex; justify-content: flex-end">
                                    <el-button type="danger" @click="delData(index, 'jz')" icon="el-icon-close"></el-button>
                                </div>

                                <div>
                                    <div class="disTitle">
                                        <span class="span-mode">兼职司机：</span>
                                        <div>
                                            <el-input
                                                v-model="part_synchronization_children[index].part_money"
                                                class="input-item1 input-item-active"
                                                placeholder="固定金额抽成"
                                            >
                                            </el-input>
                                            元
                                        </div>
                                    </div>
                                    <div class="disTitle">
                                        <span class="span-mode"></span>
                                        <div>
                                            <el-input
                                                v-model="part_synchronization_children[index].part_rate"
                                                class="input-item1 input-item-active"
                                                placeholder="订单金额百分比抽成"
                                            >
                                            </el-input>
                                            %
                                        </div>
                                    </div>

                                    <!-- 选择时间 -->
                                    <div class="disTitle">
                                        <span class="span-mode">抽成生效时间：</span>
                                        <div>
                                            <el-time-picker
                                                v-model="part_synchronization_children[index].time_start"
                                                :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                                                placeholder="抽成生效时间"
                                                value-format="HHmm"
                                                format="HH:mm"
                                                class="timeX"
                                            >
                                            </el-time-picker>
                                        </div>
                                    </div>
                                    <div class="disTitle">
                                        <span class="span-mode">抽成结束时间：</span>
                                        <div>
                                            <el-time-picker
                                                v-model="part_synchronization_children[index].time_end"
                                                :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                                                placeholder="抽成结束时间"
                                                value-format="HHmm"
                                                format="HH:mm"
                                                class="timeX"
                                            >
                                            </el-time-picker>
                                        </div>
                                    </div>
                                    <div class="modeStyle">
                                        <el-button
                                            class="edit-btn"
                                            @click="editModeBtn('part', index, checkboxChangeJ(index))"
                                            type="primary"
                                            >编辑</el-button
                                        >

                                        <div>
                                            <span class="span-mode">订单模式：</span>
                                            <div v-if="checkboxChangeJ(index).length == allModeArr_children.length">
                                                <el-tag type="info">全部</el-tag>
                                            </div>
                                            <div v-else>
                                                <el-checkbox-group
                                                    v-model="part_synchronization_children[index].part_order_mode_code_array"
                                                    disabled
                                                >
                                                    <el-checkbox
                                                        v-for="(item, index1) in checkboxChangeJ(index)"
                                                        :label="item.order_mode.order_mode_code"
                                                        :key="index1"
                                                    >
                                                        {{ item.name }}
                                                    </el-checkbox>
                                                </el-checkbox-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 按单司机 -->
                <div class="mode_submit-data">
                    <div class="mode-head">
                        <!-- 标题前小方块 -->
                        <div class="title-square"></div>
                        <!-- 标题 -->
                        <span style="display: inline-block">按单司机抽成（默认）</span>
                    </div>
                    <div class="disTitle">
                        <span class="span-mode">固定金额抽成</span>
                        <div>
                            <el-input
                                v-model="submit_data_children.two_single_money"
                                class="input-item1 input-item-active"
                                placeholder="固定金额抽成"
                            >
                            </el-input>
                            元
                        </div>
                    </div>
                    <div class="disTitle">
                        <span class="span-mode">百分比金额抽成</span>
                        <div>
                            <el-input
                                v-model="submit_data_children.two_single_rate"
                                class="input-item1 input-item-active"
                                placeholder="订单金额百分比抽成"
                            >
                            </el-input>
                            %
                        </div>
                    </div>
                    <el-button class="btn1" type="info" @click="selectTimeChangeD">自定义时间段抽成</el-button>
                    <div v-if="selectTimeD_children == true">
                        <div>
                            <div class="btnTitle">
                                <span class="title-a">抽成生效时间段:</span>
                                <el-button @click="addContent('ad')" type="success" class="btnSelect" icon="el-icon-plus"></el-button>
                            </div>

                            <div v-for="(item, index) in single_synchronization_children" :key="index" class="box-content">
                                <div style="display: flex; justify-content: flex-end">
                                    <el-button type="danger" @click="delData(index, 'ad')" icon="el-icon-close"></el-button>
                                </div>

                                <div>
                                    <div class="disTitle">
                                        <span class="span-mode">按单司机：</span>
                                        <div>
                                            <el-input
                                                v-model="single_synchronization_children[index].single_money"
                                                class="input-item1 input-item-active"
                                                placeholder="固定金额抽成"
                                            >
                                            </el-input>
                                            元
                                        </div>
                                    </div>
                                    <div class="disTitle">
                                        <span class="span-mode"></span>
                                        <div>
                                            <el-input
                                                v-model="single_synchronization_children[index].single_rate"
                                                class="input-item1 input-item-active"
                                                placeholder="订单金额百分比抽成"
                                            >
                                            </el-input>
                                            %
                                        </div>
                                    </div>

                                    <!-- 选择时间 -->
                                    <div class="disTitle">
                                        <span class="span-mode">抽成生效时间：</span>
                                        <div>
                                            <el-time-picker
                                                v-model="single_synchronization_children[index].time_start"
                                                :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                                                placeholder="抽成生效时间"
                                                value-format="HHmm"
                                                format="HH:mm"
                                                class="timeX"
                                            >
                                            </el-time-picker>
                                        </div>
                                    </div>
                                    <div class="disTitle">
                                        <span class="span-mode">抽成结束时间：</span>
                                        <div>
                                            <el-time-picker
                                                v-model="single_synchronization_children[index].time_end"
                                                :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                                                placeholder="抽成结束时间"
                                                value-format="HHmm"
                                                format="HH:mm"
                                                class="timeX"
                                            >
                                            </el-time-picker>
                                        </div>
                                    </div>
                                    <div class="modeStyle">
                                        <el-button
                                            class="edit-btn"
                                            @click="editModeBtn('single', index, checkboxChangeD(index))"
                                            type="primary"
                                            >编辑</el-button
                                        >

                                        <div>
                                            <span class="span-mode">订单模式：</span>
                                            <div v-if="checkboxChangeD(index).length == allModeArr_children.length">
                                                <el-tag type="info">全部</el-tag>
                                            </div>
                                            <div v-else>
                                                <el-checkbox-group
                                                    v-model="single_synchronization_children[index].single_order_mode_code_array"
                                                    disabled
                                                >
                                                    <el-checkbox
                                                        v-for="(item, index1) in checkboxChangeD(index)"
                                                        :label="item.order_mode.order_mode_code"
                                                        :key="index1"
                                                    >
                                                        {{ item.name }}
                                                    </el-checkbox>
                                                </el-checkbox-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- {{ activeName }} -->

        <!-- 保存按钮 如果当前模式是生效中则不展示保存按钮，空闲中的才展示保存按钮-->
        <div v-if="activeName == '2'">
            <el-button class="sava-btn" :disabled="saveLoading" v-loading="saveLoading" @click="onSubmitDig('2')" type="primary">{{
                saveLoading == true ? '保存数据中...' : '保存并使用'
            }}</el-button>
        </div>
        <div v-if="activeName == '3'">
            <el-button class="sava-btn" :disabled="saveLoading" v-loading="saveLoading" @click="onSubmitDig('3')" type="primary">{{
                saveLoading == true ? '保存数据中...' : '保存并使用'
            }}</el-button>
        </div>
        <!-- 编辑指定订单模式组件 -->
        <editMode
            :isShow="editMode_show_children"
            :data="checkedModes_children"
            :changeIndex_children="changeIndex_children"
            :checkboxSelect_children="checkboxSelect_children"
        ></editMode>
    </div>
</template>
<script>
var _this;
import editMode from './editMode.vue';
import bus from '@/components/common/bus';

export default {
    props: {
        isShow: Boolean,
        activeName: '', // 父组件传过来的tab激活 用来判断保存按钮是模式二还是模式三的
        childrenData: {} // 父组件传过来的详情接口返回数据
    },

    components: {
        editMode
    },
    data() {
        return {
            childLoading: false,
            modeCodeArray: [],
            saveLoading: false, // 保存数据loading_children
            changeIndex_children: '', // 订单模式编辑按钮点击的index
            checkboxSelect_children: '', // 编辑订单模式共用一个组件，用于区分全职，兼职，按单
            awaitPayMode_status_children: '0', // 创单抽成配置使用中状态判断
            checkedModes_children: [], // 订单模式复选框勾选数组

            // 获取订单模式查询条件
            mode_options_data_children: {
                page: 1,
                limit: 50,
                status: ''
            },
            modeAll_children: [], // 获取订单模式后 订单模式编码
            allModeArr_children: [], // 获取订单模式后 订单模式数组
            // isIndeterminate: true,
            editMode_show_children: false, // 编辑组件

            loading_children: true,

            // json格式数据
            full_synchronization_children: [], // 全职抽成生效时间段
            part_synchronization_children: [], // 兼职抽成生效时间段
            single_synchronization_children: [], // 按单抽成生效时间段

            selectTimeQ_children: false,
            selectTimeJ_children: false,
            selectTimeD_children: false,

            // tab标签当前选中项
            activeName_children: '',
            modeChange_children: '', // 使用中状态判断
            driver_insurance_children: '', // 模式一 兼职司机v-model绑定值

            submit_url_children: '/paymode/editpayModeSub',
            // open_3_pay: {
            //     val: '',
            //     alias: ''
            // },

            // 表单数据
            submit_data_children: {
                status: '',
                two_full_money: '0', //默认值为0，没有也要填0才能保存
                two_full_rate: '0',
                two_part_money: '0',
                two_part_rate: '0',
                two_single_money: '0',
                two_single_rate: '0',
                use_mode: '',
                full_synchronization: '',
                part_synchronization: '',
                single_synchronization: ''
            },

            submit_rules_children: {
                two_full_money: {
                    placeholder: '全职司机固定金额抽成',
                    rules: {
                        required: true,
                        message: '全职司机固定金额抽成为大于等于0的数字',
                        regulation: 'egt',
                        rulesData: '0'
                    }
                },

                two_full_rate: {
                    placeholder: '全职司机订单金额百分比抽成',
                    rules: {
                        required: true,
                        message: '全职司机订单金额百分比抽成为大于等于0的数字',
                        regulation: 'between',
                        rulesData: [0, 9999]
                    }
                },

                two_part_money: {
                    placeholder: '兼职司机固定金额抽成',
                    rules: {
                        required: true,
                        message: '兼职司机固定金额抽成为大于等于0的数字',
                        regulation: 'egt',
                        rulesData: '0'
                    }
                },

                two_part_rate: {
                    placeholder: '兼职司机订单金额百分比抽成',
                    rules: {
                        required: true,
                        message: '兼职司机订单金额百分比抽成为大于等于0的数字',
                        regulation: 'between',
                        rulesData: [0, 9999]
                    }
                },
                two_single_money: {
                    placeholder: '按单司机固定金额抽成',
                    rules: {
                        required: true,
                        message: '按单司机固定金额抽成为大于等于0的数字',
                        regulation: 'egt',
                        rulesData: '0'
                    }
                },

                two_single_rate: {
                    placeholder: '按单司机订单金额百分比抽成',
                    rules: {
                        required: true,
                        message: '按单司机订单金额百分比抽成为大于等于0的数字',
                        regulation: 'between',
                        rulesData: [0, 9999]
                    }
                }
            }
        };
    },
    async created() {
        _this = this;
        _this.childLoading = true;
        console.log('模式二created');
        // _this.activeName_children = _this.activeName; // 父组件切换tab标签，子组件created不执行，拿到的activeName_children不对导致保存按钮传参不对
        // console.log(_this.activeName_children, '_this.activeName_children子组件created赋值tab激活标签');

        // await _this.orderModeList(); //获取订单模式

        // await _this.payModeList(); // 获取司机抽成配置
        // await _this.awaitPayMode(); // 获取创单抽成配置
        // 接口返回值后取消页面loading

        // 等待_this.orderModeList()，_this.payModeList()，_this.awaitPayMode()三个方法都执行完在执行_this.childLoading = false
        // 但是_this.orderModeList()方法里面有一个getMode()是递归，
        //有可能第一轮getMode()走完就算_this.orderModeList()走完了，就执行了_this.childLoading = false，实际上getMode()是递归,所以还在继续走
        // 所以_this.orderModeList()需要等待getMode()也走完才可以返回resolve
        //   console.log(this.activeName,'1111111111');
        if (this.activeName == 2 || this.activeName == 3) {
            // 模式二或者创单抽成配置的时候加loading,模式一的时候不走下面方法
            // console.log(this.activeName,'1111111111');
            Promise.all([_this.orderModeList(), _this.payModeList(), _this.awaitPayMode()]).then((res) => {
                // console.log('promise');
                // 订单模式数量和接口返回的订单模式数量确定后才能计算出是否显示全部

                _this.childLoading = false;
                // console.log(_this.childLoading,'_this.childLoading');
            });
        }
    },
    computed: {
        // 显示选择的订单模式
        checkboxChangeQ() {
            return (index) => {
                let returnArray = [];
                // console.log(_this.full_synchronization_children[index].full_order_mode_code_array,'111接口返回的订单模式编码');
                // console.log(_this.allModeArr_children.length,'222订单模式接口返回的全部订单模式');

                // 已选择
                _this.full_synchronization_children[index].full_order_mode_code_array.forEach((e) => {
                    // 全部 遍历订单模式数组
                    _this.allModeArr_children.forEach((j) => {
                        // 在allModeArr_children中查找full_synchronization_children中的code
                        if (e == j.order_mode.order_mode_code) {
                            returnArray.push(j);
                        }
                    });
                });

                // 司机抽成选择的订单模式比如aaa，被删除了，但是详情接口需要把之前设置的订单模式aaa也返回
                // 全职司机订单模式是否显示全部，是根据接口返回的订单模式数据与order/orderModeLists返回的接口数量对比，如果相等就显示全部
                // 但是被删除的也返回，导致返回的接口大于order/orderModeLists返回的接口，而且点击订单模式的编辑按钮进入的订单模式编辑页面全选状态也不对
                // 解决方案就是把删除的订单模式过滤掉，然后点击编辑的时候把过滤后的订单模式编码传给订单模式编辑组件
                // _this.modeCodeArray = returnArray;
                // console.log(_this.modeCodeArray,'returnArray333'); // 如果不打印，_this.modeCodeArray没被用，就没事，但是这行打印导致就报错
                //因为_this.modeCodeArray被赋值导致数据改变，触发计算属性执行，一执行_this.modeCodeArray又改变，然后在执行，无限循环了
                //不要在计算属性内部修改数据：计算属性的“getter”函数应该只返回计算的值，而不应该在内部修改依赖的数据。这样会导致无限循环更新

                return returnArray;
            };
        },
        checkboxChangeJ() {
            // return (index) => {} 因为计算属性不能传参，但是箭头函数可以传参，所以用这种写法，这种写法就是为了传参的
            // 计算属性的触发条件是 值改变时触发，值不改变的时候就取缓存的值，跟方法相比比较节约性能
            return (index) => {
                let returnArray = [];

                // 已选择
                _this.part_synchronization_children[index].part_order_mode_code_array.forEach((e) => {
                    // 全部
                    _this.allModeArr_children.forEach((j) => {
                        // 在allModeArr_children中查找part_synchronization_children中的code
                        if (e == j.order_mode.order_mode_code) {
                            returnArray.push(j);
                        }
                    });
                });

                return returnArray;
            };
        },
        checkboxChangeD() {
            return (index) => {
                let returnArray = [];

                // 已选择
                _this.single_synchronization_children[index].single_order_mode_code_array.forEach((e) => {
                    // 全部
                    _this.allModeArr_children.forEach((j) => {
                        // 在allModeArr_children中查找single_synchronization_children中的code
                        if (e == j.order_mode.order_mode_code) {
                            returnArray.push(j);
                        }
                    });
                });

                return returnArray;
            };
        }
    },

    methods: {
        // 订单模式编辑按钮
        editModeBtn(e, changeIndex_children, allArray) {
            // allArray是接口返回的订单模式，已经过滤到被删除的订单模式
            let allArrayStr = [];
            for (let index = 0; index < allArray.length; index++) {
                allArrayStr.push(allArray[index].order_mode.order_mode_code);
            }
            // console.log(allArrayStr, '--------');
            _this.checkedModes_children = allArrayStr;

            // e代表全职兼职按单 ，changeIndex_children代表点击的index
            _this.editMode_show_children = !_this.editMode_show_children;
            _this.changeIndex_children = changeIndex_children;
            if (e == 'full') {
                // _this.checkedModes_children = _this.full_synchronization_children[changeIndex_children].full_order_mode_code_array;// 导致删除的订单模式编码也存在
                _this.checkboxSelect_children = 'full';
            } else if (e == 'part') {
                // _this.checkedModes_children = _this.part_synchronization_children[changeIndex_children].part_order_mode_code_array;
                _this.checkboxSelect_children = 'part';
            } else if (e == 'single') {
                // _this.checkedModes_children = _this.single_synchronization_children[changeIndex_children].single_order_mode_code_array;
                _this.checkboxSelect_children = 'single';
            }
        },
        // 模式二详情
        payModeList() {
            // _this.childLoading = true;
            // console.log(_this.activeName_children,'子组件payModeList，_this.activeName_children');
            return new Promise((resolve) => {
                _this
                    .$post('/paymode/payModeList')
                    .then((res) => {
                        if (_this.activeName == '2') {
                            // 如果点击模式一，则不需要给模式二数据赋值，只要点击模式二的时候才赋值
                            // 如果当前激活为模式二则赋值，这样写防止点击模式一的时候触发子组件created里面事件执行，同时执行了模式二和创单的赋值，并且父组件也执行了模式一赋值，导致页面数据问题
                            // _this.activeName_children = res.data.use_mode; // 模式一模式二tab标签激活状态，使用中的tab页激活显示，当前赋值执行后，切换tab标签需要重新给激活选项赋值，否则tab页会无法切换
                            // console.log(_this.activeName_children, '_this.activeName模式二子组件模式二赋值');
                            // this.$parent.modeChange = res.data.use_mode; // 保存数据成功后调当前接口修改父组件使用中状态;
                            _this.driver_insurance = res.data.driver_insurance; //模式一 兼职司机v-model绑定值
                            _this.submit_data_children.use_mode = res.data.use_mode; // 使用中状态的提交值

                            _this.submit_data_children.two_full_money = res.data.two_full_money; // 全职司机固定金额抽成
                            _this.submit_data_children.two_full_rate = res.data.two_full_rate; // 全职司机订单金额百分比抽成
                            _this.submit_data_children.two_part_money = res.data.two_part_money; // 兼职司机固定金额抽成
                            _this.submit_data_children.two_part_rate = res.data.two_part_rate; // 兼职司机订单金额百分比抽成
                            _this.submit_data_children.two_single_money = res.data.two_single_money; // 按单司机固定金额抽成
                            _this.submit_data_children.two_single_rate = res.data.two_single_rate; // 按单司机订单金额百分比抽成
                            _this.full_synchronization_children = JSON.parse(res.data.full_synchronization); // 全职抽成生效时间段
                            _this.part_synchronization_children = JSON.parse(res.data.part_synchronization); // 兼职抽成生效时间段
                            // console.log(_this.part_synchronization[0].part_order_mode_code_array.length, 'part_order_mode_code_array'); // 这行代码导致下面代码不执行，因为接口返回空数组的时候，这回代码就无法打印了
                            _this.single_synchronization_children = JSON.parse(res.data.single_synchronization); // 按单抽成生效时间段

                            if (_this.full_synchronization_children.length > 0) {
                                // 如果配置了全职生效时间段，则显示
                                _this.selectTimeQ_children = true;
                            }
                            if (_this.part_synchronization_children.length > 0) {
                                // 如果配置了兼职生效时间段，则显示
                                _this.selectTimeJ_children = true;
                            }
                            if (_this.single_synchronization_children.length > 0) {
                                // 如果配置了按单生效时间段，则显示
                                _this.selectTimeD_children = true;
                            }

                            this.$emit('updateUseMode', res.data.use_mode,2);

                            // console.log('子组件payModeList赋值完成');
                        }
                        // _this.childLoading = false;
                        // console.log('payModeList方法完成');
                        resolve();
                    })
                    .catch((err) => {});
            });
        },

        // 获取创单抽成配置
        awaitPayMode() {
            // _this.childLoading = true;

            // console.log(_this.activeName_children,'子组件awaitPayMode，_this.activeName_children');
            return new Promise((resolve) => {
                _this
                    .$post('/paymode/awaitPayMode')
                    .then((res) => {
                        if (_this.activeName == '3') {
                            // 如果当前激活为创单抽成则赋值，这样写防止点击模式一的时候出发子组件created里面事件执行，同时执行了模式二和创单的赋值，并且父组件也执行了模式一赋值，导致页面数据问题

                            // this.$parent.awaitPayMode_status = res.data.status; // 保存数据成功后调当前接口修改父组件switch开关状态，也就是使用中状态;

                            _this.awaitPayMode_status_children = res.data.status;
                            // 如果是创单抽成模式为激活的tab标签，则给创单抽成模式赋值
                            // console.log('当前为创单抽成模式');
                            _this.submit_data_children.status = res.data.status;
                            _this.submit_data_children.two_full_money = res.data.two_full_money;
                            _this.submit_data_children.two_full_rate = res.data.two_full_rate;
                            _this.submit_data_children.two_part_money = res.data.two_part_money;
                            _this.submit_data_children.two_part_rate = res.data.two_part_rate;
                            _this.submit_data_children.two_single_money = res.data.two_single_money;
                            _this.submit_data_children.two_single_rate = res.data.two_single_rate;

                            _this.full_synchronization_children = JSON.parse(res.data.full_synchronization);

                            _this.part_synchronization_children = JSON.parse(res.data.part_synchronization);
                            // console.log(_this.part_synchronization[0].part_order_mode_code_array.length, 'awaitPayMode');
                            _this.single_synchronization_children = JSON.parse(res.data.single_synchronization);

                            if (_this.full_synchronization_children.length > 0) {
                                _this.selectTimeQ_children = true;
                            }

                            if (_this.part_synchronization_children.length > 0) {
                                _this.selectTimeJ_children = true;
                            }
                            if (_this.single_synchronization_children.length > 0) {
                                _this.selectTimeD_children = true;
                            }

                            this.$emit('updateUseMode', res.data.status,'3');

                            // console.log('子组件awaitPayMode赋值完成');
                        }
                        // _this.childLoading = false;
                        // console.log('awaitPayMode方法完成');

                        resolve();
                    })
                    .catch((err) => {});
            });
        },

        //获取订单模式
        async orderModeList() {
            return new Promise((resolve) => {
                //  离await最近的方法前面要加async
                // vue promise 等待另一个接口里面的递归方法执行完在resolve
                _this.allModeArr_children = []; // 订单模式数组
                _this.modeAll_children = []; // 订单模式编码
                // console.log('订单模式1');

                //  _this.getMode(resolve).then((res) =>{
                //     console.log(333);

                //     resolve();

                // });
                _this.getMode(resolve);
                // console.log('订单模式2');

                // resolve();

                // console.log('orderModeList方法完成');
            });
        },

        getMode(resolve) {
            _this
                .$post('/order/orderModeLists', _this.mode_options_data_children)
                .then((res) => {
                    for (let i = 0; i < res.data.length; i++) {
                        _this.allModeArr_children.push(res.data[i]);
                    }

                    if (_this.mode_options_data_children.page * _this.mode_options_data_children.limit < res.count) {
                        _this.mode_options_data_children.page += 1;
                        _this.getMode(resolve);
                    } else {
                        for (let j = 0; j < _this.allModeArr_children.length; j++) {
                            _this.modeAll_children.push(_this.allModeArr_children[j].order_mode.order_mode_code);

                            // console.log(_this.modeAll_children.length, '_this.modeAll_children长度------=======');
                        }
                        // for循环执行完在 resolve
                        // 把订单模式编码单独放一个数组里面
                        // for (let index = 0; index < _this.allModeArr_children.length; index++) {
                        //     _this.modeCodeArray.push(_this.allModeArr_children[index].order_mode.order_mode_code);
                        // }

                        resolve();

                        // console.log(_this.allModeArr_children.length, '_this.allModeArr_children.length--getMode走完');
                    }
                })
                .catch((err) => {});
        },
        //添加按钮 e='qz' 全职司机 e='jz' 兼职司机
        addContent(e) {
            if (e == 'qz') {
                var obj_full_synchronization_children = {
                    full_money: '',
                    full_rate: '',
                    time_start: '',
                    time_end: '',
                    full_order_mode_code_array: _this.modeAll_children
                };

                // 每点击一次在数组中加入一个对象
                _this.full_synchronization_children.push(obj_full_synchronization_children);
            } else if (e == 'jz') {
                var obj_part_synchronization_children = {
                    part_money: '',
                    part_rate: '',
                    time_start: '',
                    time_end: '',
                    part_order_mode_code_array: _this.modeAll_children
                };

                // 每点击一次在数组中加入一个对象
                _this.part_synchronization_children.push(obj_part_synchronization_children);
            } else if (e == 'ad') {
                var obj_single_synchronization_children = {
                    single_money: '',
                    single_rate: '',
                    time_start: '',
                    time_end: '',
                    single_order_mode_code_array: _this.modeAll_children
                };

                // 每点击一次在数组中加入一个对象
                _this.single_synchronization_children.push(obj_single_synchronization_children);
            }
        },
        // 删除按钮
        delData(index, e) {
            if (e == 'qz') {
                // 删除数组中对应index的数据
                _this.full_synchronization_children.splice(index, 1);
            } else if (e == 'jz') {
                // 删除数组中对应index的数据
                _this.part_synchronization_children.splice(index, 1);
            } else if (e == 'ad') {
                // 删除数组中对应index的数据
                _this.single_synchronization_children.splice(index, 1);
            }
        },

        selectTimeChangeQ() {
            _this.selectTimeQ_children = !_this.selectTimeQ_children;
        },
        selectTimeChangeJ() {
            _this.selectTimeJ_children = !_this.selectTimeJ_children;
        },
        selectTimeChangeD() {
            _this.selectTimeD_children = !_this.selectTimeD_children;
        },

        // 提交

        onSubmitDig(e) {
            _this.submit_data_children.use_mode = e;
            _this.submit_data_children.status = _this.awaitPayMode_status_children;

            if (_this.submit_data_children.use_mode == '3') {
                _this.submit_url_children = '/paymode/awaitPayModeSub';
            } else if (_this.submit_data_children.use_mode == '2') {
                _this.submit_url_children = '/paymode/editpayModeSub';
            }

            var array_data = _this.full_synchronization_children;

            var array_data2 = _this.part_synchronization_children;
            var array_data3 = _this.single_synchronization_children;
            var reg = /^[0-9]+.?[0-9]*$/;
            if (_this.selectTimeQ_children) {
                // 第一个开关打开 全职

                for (var i = 0; i < array_data.length; i++) {
                    if (
                        !reg.test(_this.full_synchronization_children[i].full_money) ||
                        _this.full_synchronization_children[i].full_money < 0
                    ) {
                        _this.$message.error('全职司机自定义时间配置固定金额应为大于等于0的数字');
                        return;
                    }
                    if (
                        !reg.test(_this.full_synchronization_children[i].full_rate) ||
                        _this.full_synchronization_children[i].full_rate < 0
                    ) {
                        _this.$message.error('全职司机自定义时间配置抽成百分比应为大于等于0的数字');
                        return;
                    }
                    if (
                        !reg.test(_this.full_synchronization_children[i].time_start) ||
                        _this.full_synchronization_children[i].time_start < 0
                    ) {
                        _this.$message.error('全职司机自定义时间配置抽成生效时间为必填项');
                        return;
                    }
                    if (!reg.test(_this.full_synchronization_children[i].time_end) || _this.full_synchronization_children[i].time_end < 0) {
                        _this.$message.error('全职司机自定义时间配置抽成结束时间为必填项');
                        return;
                    }
                }
            }

            if (_this.selectTimeJ_children) {
                // 第二个开关打开 兼职

                for (var i = 0; i < array_data2.length; i++) {
                    if (
                        !reg.test(_this.part_synchronization_children[i].part_money) ||
                        _this.part_synchronization_children[i].part_money < 0
                    ) {
                        _this.$message.error('兼职司机自定义时间配置固定金额应为大于等于0的数字');
                        return;
                    }
                    if (
                        !reg.test(_this.part_synchronization_children[i].part_rate) ||
                        _this.part_synchronization_children[i].part_rate < 0
                    ) {
                        _this.$message.error('兼职司机自定义时间配置抽成百分比应为大于等于0的数字');
                        return;
                    }
                    if (
                        !reg.test(_this.part_synchronization_children[i].time_start) ||
                        _this.part_synchronization_children[i].time_start < 0
                    ) {
                        _this.$message.error('兼职司机自定义时间配置抽成生效时间为必填项');
                        return;
                    }
                    if (!reg.test(_this.part_synchronization_children[i].time_end) || _this.part_synchronization_children[i].time_end < 0) {
                        _this.$message.error('兼职司机自定义时间配置抽成结束时间为必填项');
                        return;
                    }
                }
            }

            if (_this.selectTimeD_children) {
                // 第三个开关打开 按单

                for (var i = 0; i < array_data3.length; i++) {
                    if (
                        !reg.test(_this.single_synchronization_children[i].single_money) ||
                        _this.single_synchronization_children[i].single_money < 0
                    ) {
                        _this.$message.error('按单司机自定义时间配置固定金额应为大于等于0的数字');
                        return;
                    }
                    if (
                        !reg.test(_this.single_synchronization_children[i].single_rate) ||
                        _this.single_synchronization_children[i].single_rate < 0
                    ) {
                        _this.$message.error('按单司机自定义时间配置抽成百分比应为大于等于0的数字');
                        return;
                    }
                    if (
                        !reg.test(_this.single_synchronization_children[i].time_start) ||
                        _this.single_synchronization_children[i].time_start < 0
                    ) {
                        _this.$message.error('按单司机自定义时间配置抽成生效时间为必填项');
                        return;
                    }
                    if (
                        !reg.test(_this.single_synchronization_children[i].time_end) ||
                        _this.single_synchronization_children[i].time_end < 0
                    ) {
                        _this.$message.error('按单司机自定义时间配置抽成结束时间为必填项');
                        return;
                    }
                }
            }

            //如果添加自定义时间段开关是关的，提交数据的时候，清空已经填写的值
            if (!_this.selectTimeQ_children) {
                _this.submit_data_children.full_synchronization = JSON.stringify([]);
            } else {
                // 将json格式数据转换成字符串格式赋值给要提交的对象
                _this.submit_data_children.full_synchronization = JSON.stringify(_this.full_synchronization_children);
            }

            //如果添加自定义时间段开关是关的，提交数据的时候，清空已经填写的值
            if (!_this.selectTimeJ_children) {
                _this.submit_data_children.part_synchronization = JSON.stringify([]);
            } else {
                // 将json格式数据转换成字符串格式赋值给要提交的对象
                _this.submit_data_children.part_synchronization = JSON.stringify(_this.part_synchronization_children);
            }

            if (!_this.selectTimeD_children) {
                _this.submit_data_children.single_synchronization = JSON.stringify([]);
            } else {
                // 将json格式数据转换成字符串格式赋值给要提交的对象
                _this.submit_data_children.single_synchronization = JSON.stringify(_this.single_synchronization_children);
            }
            _this.saveLoading = true;
            bus.$on('btnStatus', (val) => {
                _this.saveLoading = val;
                // 接收http.js if (rules !== {}) {}里面的bus.$emit('btnStatus', false)，验证不通过，取消按钮loading
            });



            _this.$post(_this.submit_url_children, _this.submit_data_children, _this.submit_rules_children).then((res) => {
                _this.saveLoading = false;

                _this.$message.success('保存成功');

                if (_this.submit_data_children.use_mode == '3') {
                    _this.awaitPayMode();
                } else if (_this.submit_data_children.use_mode == '2') {
                    _this.payModeList();
                }
            });
        }
    }
};
</script>

<style scoped>
.edit-btn {
    float: right;
}

.modeStyle {
    margin-top: 10px;
}

.modeStyle > div > div {
    margin-left: 30px;
    margin-top: 10px;
    max-width: 100%;
}

.second-main-wrap {
    display: flex;
    justify-content: space-around;
}

.title h2 {
    font-weight: 700;
    margin-bottom: 30px;
    margin-right: 10px;
    color: #000;
    font-size: 24px;
    display: inline-block;
}

.title span {
    font-size: 16px;
    color: #606266;
}

.btn1 {
    margin-left: 10px;
    margin-top: 10px;
    width: 130px;
}

.timeX {
    width: 150px;
    margin-left: 10px;
    /* margin-top: 10px; */
}

.full-driver {
    margin-top: 20px;
    margin-left: 70px;
    margin-right: 10px;
}

.use_mode-btn {
    margin-left: 20px;
    height: 30px;
}

.mode-head {
    display: flex;
    align-items: center;
    margin-top: 30px;
}

.mode-title {
    display: inline-block;
    margin-bottom: 20px;
}

.mode_submit-data {
    margin: 20px 0 30px;
    width: 32%;
}

.mode-name {
    width: 500px;
    margin: 20px auto 0;
}

.modea {
    display: flex;
    justify-content: space-between;
}

.line {
    background-color: #909399;
    width: 1px;
}

.sava-btn {
    margin: 0 auto;
    display: block;
    margin-top: 10px;
}

.input-item1 {
    max-width: 160px !important;
    width: 60% !important;
    box-sizing: content-box !important;
}

.input-item-active {
    padding-left: 10px;
}

.title-square {
    background-color: #409eff;
    display: inline-block;
    width: 10px;
    height: 30px;
    margin-right: 5px;
}

.title-a {
    margin-top: 15px;
    display: inline-block;
}

.box-content {
    background-color: #eee;
    padding: 10px;
    border-radius: 10px;
    margin-bottom: 20px;
    width: 100%;
    box-sizing: border-box;
}

.span-mode {
    display: inline-block;
    width: 110px;
    text-align: right;
}

.disTitle {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.btnTitle {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
}

.btnSelect {
    width: 50px;
    height: 40px;
    margin-bottom: 15px;
}
</style>
<style>
.modeStyle-contain .el-checkbox {
    width: 200px;
}
</style>